import { render, staticRenderFns } from "./ModalGrupoComissao.vue?vue&type=template&id=87bd9eee"
import script from "./ModalGrupoComissao.vue?vue&type=script&lang=js"
export * from "./ModalGrupoComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports